// useHistoricoConversas.js ou useHistoricoConversas.ts
import { useState, useEffect } from "react";
import { usePergunta } from "../contexts/PerguntaContext";
import { EmpreenderApps } from "../files/AppsArray";
import { lerItem } from "../lib/armazenamentoSeguro";

interface MensagemData {
  id: string;
  texto: string;
  tipo: "usuario" | "assistente";
  artigos: any[];
  whatsapps: any[];
  idRespostaGptSak: number;
  feedback?: "sim" | "nao";
  anexoTexto?: string;
  // Respostas da IA da central (api/conversar.ts).
  opcoes?: string[];
  artigoUsado?: string | null;
  precisaHumano?: boolean;
  resumoCaso?: string;
  fonte?: "ia";
  registro?: number | null; // número da resposta nas métricas (/admin/metricas)
  artigoUsadoTitulo?: string | null;
  artigoHtml?: string | null;
}

interface ConversasStorage {
  [key: string]: { [conversaId: string]: MensagemData[] };
}

const ObterHistoricoConversa = (slugAtual: string, conversaAtual: string) => {
  const [historico, setHistorico] = useState<MensagemData[]>([]);
  const { pergunta } = usePergunta();

  const dadosApp = EmpreenderApps.find(
    (item) => item.slug === slugAtual || item.sluges === slugAtual
  );

  const slugAmigavel = dadosApp?.slugamigavel || "";

  useEffect(() => {
    const armazenado = lerItem("conversas_storage");

    if (armazenado) {
      try {
        const conversasStorage: ConversasStorage = JSON.parse(armazenado);

        if (conversasStorage[slugAmigavel]?.[conversaAtual]) {
          const conversasDoSlug = Object.values(
            conversasStorage[slugAmigavel][conversaAtual]
          ).flat();
          setHistorico(conversasDoSlug);
        }
      } catch (error) {
        console.error("Erro ao parsear as conversas:", error);
      }
    }
  }, []);

  useEffect(() => {
    const armazenado = lerItem("conversas_storage");

    if (armazenado) {
      try {
        const conversasStorage: ConversasStorage = JSON.parse(armazenado);

        if (conversasStorage[slugAmigavel]?.[conversaAtual]) {
          const conversasDoSlug = Object.values(
            conversasStorage[slugAmigavel][conversaAtual]
          ).flat();
          setHistorico(conversasDoSlug);
        }
      } catch (error) {
        console.error("Erro ao parsear as conversas:", error);
      }
    }
  }, [slugAtual, conversaAtual, pergunta]);

  return historico;
};

export default ObterHistoricoConversa;
